import { useEffect, useState, useRef, memo } from "react";
import {
  Col,
  Container,
  Row,
  Form,
  Accordion,
  Modal,
  Button,
} from "react-bootstrap";
import { Helmet } from "react-helmet";
// import "../../../Assets/css/single_product.css";
import ToggleButton from "react-bootstrap/ToggleButton";
import Order_include from "./Order_include";
import Rings from "./Rings";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import axios from "axios";
import {
  base_url,
  img_url,
  klaviyo_url,
  logout,
  postHeader,
  s3_img_url,
} from "../../../Helper/request";
import {
  Link,
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  Single_product_skeleton,
  Single_product_ring_skeleton,
} from "./Single_product_skeleton";
import { wishlistlength } from "../../../Reducer/wishlistReducer";
import { productcount } from "../../../Reducer/productReducer";
import InnerImageZoom from "react-inner-image-zoom";
import "react-inner-image-zoom/lib/InnerImageZoom/styles.css";
import { cartlength } from "../../../Reducer/cartReducer";
import Tooltip from "react-bootstrap/Tooltip";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import { ToastContainer, toast } from "react-toastify";
import InPersonConsultation from "../../pages/InPersonConsultation";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import {
  FacebookShareButton,
  EmailShareButton,
  PinterestShareButton,
  TwitterShareButton,
} from "react-share";
import { metaDetails } from "../../../Reducer/metaReducer";
import { clickklevu } from "../../../Reducer/homeReducer";
import { Player } from "video-react";
import { MobileView, BrowserView, isMobile } from "react-device-detect";
import { shippingBus } from "../../../Assets/svg";

import { Swiper, SwiperSlide } from "swiper/react";

import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Pagination, Navigation } from "swiper/modules";
import Dropdown from "react-bootstrap/Dropdown";
import useAffirmScript from "../../Front/UseAffirmScript";


const LongText = ({ content, limit }) => {
  const [showAll, setShowAll] = useState(false);

  if (content?.length <= limit) {
    return <div>{content}</div>;
  }
  if (showAll) {
    return (
      <div>
        {content}
        <span onClick={() => setShowAll(false)}>Read less</span>
      </div>
    );
  }
  const toShow = content?.substring(0, limit) + "...";
  return (
    <div>
      {toShow}
      <span onClick={() => setShowAll(true)}>Read more</span>
    </div>
  );
};

const Single_product = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [selectedStoneQlty, setSelectedStoneQlty] = useState("");

  const { slug, group_id, stone_quality } = useParams(); //const stone_quality = searchParams.get("stone_quality");

  useEffect(() => {
    if (stone_quality) {
      setSelectedStoneQlty(stone_quality);
    }

  }, [stone_quality]);


  const [screenWidth, setScreenWidth] = useState(window.screen.width);
  const resizeScreen = () => {
    setScreenWidth(window.innerWidth);
  };
  useEffect(() => {
    resizeScreen();
    window.addEventListener("resize", resizeScreen);
    return () => {
      window.removeEventListener("resize", resizeScreen);
    };
  });

  const [freeGiftDec, setfreeGiftDec] = useState(false);
  const [toggle, setToggle] = useState(false);

  const [bookAppointmentShow, setbookAppointmentShow] = useState(false);
  const bookAppointment_handleClose = () => setbookAppointmentShow(false);
  const bookAppointment_handleShow = () => setbookAppointmentShow(true);

  const [freeGiftShow, setfreeGiftShow] = useState(false);
  const freeGift_handleClose = () => setfreeGiftShow(false);
  const freeGift_handleShow = () => setfreeGiftShow(true);
  const [filterDataMain, setFilterDataMain] = useState([]);

  const [isringsize, setIsringsize] = useState(false);
  const [isEngravingHas, setIsEngravingHas] = useState(false);
  const [modalshow, modalsetShow] = useState(false);
  const [drophintimg, setDrophintimg] = useState("");
  const [promodata, setPromodata] = useState("");
  const [initialText, setInitialText] = useState("");
  const [remainingText, setRemainingText] = useState("");
  const [showMore, setShowMore] = useState("");
  const [offerProductValue, setOfferProductValue] = useState("");
  const [fontFamily, setfontFamily] = useState("");
  const [shippingAlert, setshippingAlert] = useState([]);

  function handleShowMore(val) {
    setShowMore(false);
    setOfferProductValue(val);
    const initialText = val?.description.substring(0, 260);
    setInitialText(initialText);
  }
  const handleClose = () => modalsetShow(false);
  const handleShow = () => modalsetShow(true);

  const navigate = useNavigate();
  const options = {
    infinite: true,
    slidesToShow: 1,
    margin: 10,
    dots: true,
    arrows: false,
  };

  let settings_1 = {
    dots: false,
    infinite: false,
    slidesToShow: 8,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 4,
          arrows: true,
        },
      },
      {
        breakpoint: 1000,
        settings: {
          slidesToShow: 4,
          arrows: true,
        },
      },
      {
        breakpoint: 1300,
        settings: {
          slidesToShow: 12,
          arrows: true,
        },
      },
    ],
  };
  let settings_2 = {
    dots: false,
    arrows: true,
    infinite: true,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 4,
    prevArrow: "",
    nextArrow: "",
    autoplay: true,
    autoplaySpeed: 3000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 5,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
          arrows: false,
        },
      },
      {
        breakpoint: 10,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
          arrows: false,
        },
      },
    ],
  };

  const dispatch = useDispatch();

  const location = useLocation();

  const userdata = useSelector((state) => state.persistedReducer.home.user);
  const metaData = useSelector((state) => state.persistedReducer.meta.meta);

  const detailSlug = useSelector(
    (state) => state.persistedReducer.product.detailSlug
  );
  const klevuclicked = useSelector(
    (state) => state.persistedReducer.home.clickklevu
  );
  const session_id = useSelector(
    (state) => state.persistedReducer.home.session_id
  );
  const [productdetail, setProductdetail] = useState([]);
  const [warranyContent, setWarranyContent] = useState([]);
  const [filterdetail, setFilterdetail] = useState([]);
  const [ringsize, setRingsize] = useState("");
  const [recentlydata, setRecentlydata] = useState([]);
  const [suggesteddata, setSuggesteddata] = useState([]);
  const [is_engraving, setIs_engraving] = useState(null);
  const [engravingtext, setEngravingtext] = useState("");
  const [loader, setLoader] = useState(true);
  const [loader2, setLoader2] = useState(true);
  const [customField, setCustomField] = useState(false);
  // const subject = 'Check out this awesome website!';
  // const body = 'I found this amazing website. You should check it out!';
  const separator = "\n";
  // useEffect(() => {
  //   const affirmConfig = {
  //     public_api_key: "C43KC6BBHCNCVPUM",
  //     script: "https://cdn1.affirm.com/js/v2/affirm.js",
  //   };

  //   window._affirm_config = affirmConfig;

  //   (function (l, g, m, e, a, f, b) {
  //     var d,
  //       c = l[m] || {},
  //       h = document.createElement(f),
  //       n = document.getElementsByTagName(f)[0],
  //       k = function (a, b, c) {
  //         return function () {
  //           a[b]._.push([c, arguments]);
  //         };
  //       };
  //     c[e] = k(c, e, "set");
  //     d = c[e];
  //     c[a] = {};
  //     c[a]._ = [];
  //     d._ = [];
  //     c[a][b] = k(c, a, b);
  //     a = 0;
  //     for (b = "set add save post open empty reset on off trigger ready setProduct".split(" "); a < b.length; a++)
  //       d[b[a]] = k(c, e, b[a]);
  //     a = 0;
  //     for (b = ["get", "token", "url", "items"]; a < b.length; a++) d[b[a]] = function () {};
  //     h.async = true;
  //     h.src = g[f];
  //     n.parentNode.insertBefore(h, n);
  //     delete g[f];
  //     d(g);
  //     l[m] = c;
  //   })(window, affirmConfig, "affirm", "checkout", "ui", "script", "ready");
  // }, []);

  useEffect(() => {
    productdetailapi(group_id, slug, stone_quality, filterDataMain);

    return () => {
      controller.abort();
      controller2.abort();
    };
  }, [selectedStoneQlty]);

  window.affirm.ui.ready(function () {
    window.affirm.ui.refresh();
  });
  const trackProductEvent = (product) => {
    const gaProducts = {
      item_id: product?.product_id,
      item_name: product?.name,
      price: product?.price,
    };
    if (window.gtag) {
      window.gtag("event", "view_item", {
        event: "view_item",
        currency: "USD",
        value: product?.price,
        items: gaProducts,
        ecommerce: {
          items: gaProducts,
        },
      });
    }
  };
  // klaviyo add to viewed product event
  async function kleviyoTracking(params) {
    var item = {
      ProductName: params?.name,
      ProductID: params?.product_id,
      SKU: params?.sku,
      Categories: params?.category_name,
      ImageURL: params?.product_image[0]?.url,
      URL: window.location.href,
      Brand: params?.collection,
      Price: params?.price,
    };
    if (window?.klaviyo) {
      window.klaviyo.push(["track", "Viewed Product", item]);
    }
  }
  // klaviyo add to cart event start
  // klaviyo add to cart event start
  function klavito_addToCart() {
    const item = {
      ProductID: productdetail?.product_id,
      ProductName: productdetail?.name,
      price: productdetail?.price,
      SKU: productdetail?.sku,
      Categories: productdetail?.category_name,
      Page_URL: window.location.href,
      Image_Url: productdetail?.product_image[0]?.url,
    };
    if (window?.klaviyo) {
      window.klaviyo.push(["track", "Added to Cart", item]);
    }
  }
  // klaviyo add to cart event End
  //************ */ klaviyo add to Wishlist event *********start

  function klaviyo_Wishlist(params) {
    var item = {
      ProductID: params?.product_id,
      ProductName: params?.name,
      Price: params?.price,
      SKU: params?.sku,
      Categories: params?.category_name,
      ImageURL: params?.product_image[0]?.url,
      Page_URL: window.location.href,
    };

    if (window?.klaviyo) {
      window.klaviyo.push(["track", "Added to wishlist", item]);
    }
  }
  // *********klaviyo add to Wishlist event*********** End
  //******Klaviyo events Remove From Wishlist....****** Start
  function kleviyoRemoveWishlist(val) {
    var item = {
      ProductID: val?.product_id,
      ProductName: val?.name,
      price: val?.price,
      Image_Url: val?.product_image[0]?.url,
      Page_URL: window.location.href,
    };
    if (window?.klaviyo) {
      window.klaviyo.push(["track", "Remove From Wishlist", item]);
    }
  }

  const controller = new AbortController();
  const productdetailapi = async (group_id, slug, stone_quality, filterdata, title) => {
    setLoader(true);
    const data = {
      group_id,
      slug,
      stone_quality: stone_quality ? stone_quality : "",
      user_id: userdata?.user_id ? userdata?.user_id : "",
      session_id,
      selecteddata: filterdata ? filterdata : [],
      token: userdata?.token ? userdata?.token : "",
      current_filter_title: title,
    };
    await axios
      .post(base_url + "/product/productdetail", data, {
        headers: postHeader,
        signal: controller.signal,
      })
      .then(async (res) => {
        if (res.data.status == 1) {
          setshippingAlert(res.data.data?.shipping_alert);
          const metadata = {
            meta_title: res.data.data?.product_details?.meta_title,
            meta_description: res.data.data?.product_details?.meta_description,
            meta_keywords: res.data.data?.product_details?.meta_keywords,
          };
          dispatch(metaDetails(metadata));
          suggestedlist();
          recentlyAdded(res.data.data?.product_details?.product_id);
        
          if (
            window.location.pathname !=
            "/product-detail/" +
            res.data.data?.product_details?.group_id +
            "/" +
            res.data.data?.product_details?.slug
          ) {
            let replaceUrl =
              "/product-detail/" +
              res.data.data?.product_details?.group_id +
              "/" +
              res.data.data?.product_details?.slug;
            if (stone_quality) {
              replaceUrl = replaceUrl + "/" + stone_quality.replaceAll("+/", "%2B%2F");
            }
            navigate(
              replaceUrl,
              {
                replace: true,
              }
            );
          }
            if(!window.location.pathname.includes("custom-product-detail/") && res?.data?.data?.product_details?.is_custom_product==="1"	){
              const urlForCustomProduct= "/custom-product-detail/" +
              res.data.data?.product_details?.group_id +
              "/" +
              res.data.data?.product_details?.slug;
              
              navigate(
              urlForCustomProduct,
              {
                replace: true,
              }
            );
          }
          if (res.data.message != "") {
            alert(res.data.message);
          }
          setProductdetail(res.data.data?.product_details);
          // stoneQ(res.data.data?.product_details)
          setWarranyContent(res.data.data?.warrany_content);
          setFilterdetail(res.data.data?.filter_details);
          trackProductEvent(res.data.data?.product_details)
          kleviyoTracking(res.data.data?.product_details);
          if (res.data.data && !stone_quality) {
            res?.data?.data?.product_details?.stone_quality?.map((e, i) =>
              e?.selected ? setSelectedStoneQlty(e?.label) : setSelectedStoneQlty(""))
          }

          setTimeout(() => {
            function updateParentClass() {
              const child = document.querySelector(".swiper-button-lock");
              if (child && child.classList.contains("swiper-button-lock")) {
                child.parentElement.classList.add("swiper-backface-hidden1");
              } else if (child) {
                child.parentElement.classList.remove("swiper-backface-hidden1");
              }
            }

            updateParentClass();
            const observer = new MutationObserver(updateParentClass);
            const targetNode = document.querySelector(".swiper-button-lock");

            if (targetNode) {
              observer.observe(targetNode, { attributes: true, attributeFilter: ["class"] });
            }

          }, 1000);
        } else if (res.data.status == 2) {
          logout();
        } else {
          setProductdetail([]);
        }
        setLoader2(false);
        setLoader(false);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  // video player change start
  const VideoComponent = memo(
    function MyVideoComponent({ url, itemType }) {
      // only renders if url have changed!

      return (
        <>
          {itemType == 1 ? (
            // <GalleryImage url={item?.url} itemType={item?.type}/>
            <img className="img-fluid" src={url} alt="Weddign Day Diamonds" />
          ) : (
            <Player
              key={url}
              width={300}
              height={300}
              muted={true}
              playsInline={true}
              autoPlay={true}

              loop={true}
              controls={false}
            >
              <source src={url} />
            </Player>
          )}
        </>
      );
    },
    [productdetail]
  );
  // const VideoComponent = memo(function MyVideoComponent({ url }) {
  //   // only renders if url have changed!
  //   return (
  //     <Player
  //       key={url}
  //       width={300}
  //       height={300}
  //       muted={true}
  //       playsInline={true}
  //       autoPlay={true}
  //       loop={true}
  //       controls={false}
  //     >
  //       <source src={url} />
  //     </Player>
  //   );
  // });
  // video player change end
  const controller2 = new AbortController();
  const suggestedlist = async () => {
    const data = {
      group_id,
      slug,
      user_id: userdata?.user_id ? userdata?.user_id : "",
      session_id,
      token: userdata?.token ? userdata?.token : "",
    };
    await axios
      .post(base_url + "/product/productsuggestedlist", data, {
        headers: postHeader,
        signal: controller2.signal,
      })
      .then((res) => {
        if (res.data.status == 1) {
          setSuggesteddata(res.data.data?.result);
        } else if (res.data.status == 2) {
          logout();
        } else {
          setSuggesteddata([]);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const recentlyAdded = async (product_id) => {
    const data = {
      product_id,
      user_id: userdata?.user_id ? userdata?.user_id : "",
      session_id,
      token: userdata?.token ? userdata?.token : "",
    };
    await axios
      .post(base_url + "/product/addToRecent", data, {
        headers: postHeader,
      })
      .then((res) => {
        if (res.data.status == 1) {
          setRecentlydata(res.data.data);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const onchangeselect = (val, title) => {
    var changedata = [...filterdetail];
    changedata = changedata?.map((obj) =>
      obj.title == title ? Object.assign({}, obj, { selected: val }) : obj
    );
    // setFilterdetail(changedata);
    setFilterDataMain(changedata);
    productdetailapi(group_id, slug, stone_quality, changedata, title);

    return () => {
      controller.abort();
    };
  };
  // ga4 add_to_wishlist---------start
  const WishlistProductEvent = () => {
    const gaProducts = {
      item_id: productdetail?.product_id,
      item_name: productdetail?.name,
      price: productdetail?.price,
    };
    if (window.gtag) {
      window.gtag("event", "add_to_wishlist", {
        event: "add_to_wishlist",
        currency: "USD",
        value: productdetail?.price,
        ecommerce: {
          currency: "USD",
          value: productdetail?.price,
          items: [gaProducts],
        },
      });
    }
  };
  // ga4 add_to_wishlist---------End
  const add_to_wishlist = async (group_id, product_id, index, val) => {
    // klaviyo_Wishlist()
    const data = {
      user_id: userdata?.user_id ? userdata?.user_id : "",
      token: userdata?.token ? userdata?.token : "",
      stone_quality: selectedStoneQlty ? selectedStoneQlty : "",
      session_id,
      product_id,
      group_id,
    };
    await axios
      .post(base_url + "/product/add_to_wishlist", data, {
        headers: postHeader,
      })
      .then((res) => {
        if (res.data.status == 1) {
          WishlistProductEvent();
          dispatch(wishlistlength(res.data.data.count));
          if (index == undefined) {
            const product = Object.assign({}, productdetail, {
              is_wishlist: res.data.data.wishlist_id,
            });
            setProductdetail(product);
          } else {
            suggestedlist();
            return () => {
              controller2.abort();
            };
          }
        } else if (res.data.status == 2) {
          logout();
        } else {
          dispatch(productcount(0));
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
  // ga4 add_to_cart---------start
  const AddCartProductEvent = () => {
    const gaProducts = {
      item_id: productdetail?.product_id,
      item_name: productdetail?.name,
      price: productdetail?.price,
    };
    if (window.gtag) {
      window.dataLayer = window.dataLayer || [];
      function gtag() {
        window.dataLayer.push(arguments);
      }
      gtag("event", "add_to_cart", {
        event: "add_to_cart",
        currency: "USD",
        value: productdetail?.price,
        ecommerce: {
          items: [gaProducts],
        },
      });
    }
  };
  // ga4 add_to_cart---------End
  const add_to_cart = async (e, product_id) => {
    e.preventDefault();
    if (ringsize == "" && productdetail?.isring_size_available) {
      setIsringsize(true);
    } else {
      if (engravingtext == "" && is_engraving == 1) {
        setIsEngravingHas(true);
      } else {
        AddCartProductEvent(e);
        klavito_addToCart();
        const data = {
          user_id: userdata?.user_id ? userdata?.user_id : "",
          token: userdata?.token ? userdata?.token : "",
          session_id,
          product_id,
          quantity: 1,
          ring_size: ringsize,
          engraving_text: engravingtext,
          engraving_font: fontFamily,
          is_engraving,
          stone_quality: selectedStoneQlty ? selectedStoneQlty : "",
        };
        // window.woopra.track("add_to_cart", {
        //   item_description: data,
        // });
        await axios
          .post(base_url + "/order/add_to_cart", data, {
            headers: postHeader,
          })
          .then((res) => {
            if (res.data.status == 1) {
              dispatch(cartlength(res.data.data.total_count));
              navigate("/cart");
            } else if (res.data.status == 2) {
              logout();
            } else {
              dispatch(productcount(0));
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    }
  };
  const [loaderApi, setloaderApi] = useState(false);
  const clearAll = (e) => {
    sethintData({
      ...hintData,
      from_name: "",
      from_email: "",
      to_name: "",
      to_email: "",
      message: "",
    });
  };
  const [hintData, sethintData] = useState({
    from_name: "",
    from_email: "",
    to_name: "",
    to_email: "",
    message: "",
  });

  const [validations, setValidations] = useState({
    from_name: "",
    from_email: "",
    to_name: "",
    to_email: "",
  });

  const [errors, seterrors] = useState({});
  const inputHandler = (e) => {
    sethintData({
      ...hintData,
      [e.target.name]: e.target.value,
    });
  };

  const validateAll = () => {
    const validations = {
      from_name: "",
      from_email: "",
      to_name: "",
      to_email: "",
    };
    let isValid = true;

    if (!hintData.from_email) {
      validations.from_email = "From Email is required";
      isValid = false;
    }
    if (!hintData.to_email) {
      validations.to_email = "From Email is required";
      isValid = false;
    }

    if (hintData.from_email && !/\S+@\S+\.\S+/.test(hintData.from_email)) {
      validations.from_email = "Email format must be as example@mail.com";
      isValid = false;
    }
    if (hintData.to_email && !/\S+@\S+\.\S+/.test(hintData.to_email)) {
      validations.to_email = "Email format must be as example@mail.com";
      isValid = false;
    }

    if (!isValid) {
      setValidations(validations);
    }

    return isValid;
  };

  const validateOne = (e) => {
    const { name } = e.target;
    const value = hintData[name];
    let message = "";

    if (!value) {
      message = `${name} is required`;
    }

    if (value && name === "from_email" && !/\S+@\S+\.\S+/.test(value)) {
      message = "Email format must be as example@mail.com";
    }
    if (value && name === "to_email" && !/\S+@\S+\.\S+/.test(value)) {
      message = "Email format must be as example@mail.com";
    }

    setValidations({ ...validations, [name]: message });
  };
  const HintSubmit = (e) => {
    e.preventDefault();
    const isValid = validateAll();

    if (!isValid) {
      return false;
    }

    setloaderApi(true);
    const successToastId = 'success-toast-id';
    const iData = {
      product_id: productdetail.product_id,
      group_id: productdetail.group_id,
      from_name: hintData.from_name,
      from_email: hintData.from_email,
      to_name: hintData.to_name,
      to_email: hintData.to_email,
      message: hintData.message,
    };
    const options = {
      method: "POST",
      headers: postHeader,
    };

    axios.post(base_url + "/common/drop_hint", iData, options).then((res) => {
      if (res?.data?.status === 1) {

        if (!toast.isActive(successToastId)) {
          toast.success(res?.data?.message, {
            autoClose: false,
            closeOnClick: true,
            toastId: successToastId,
          });
        }
        clearAll();
        setloaderApi(false);
      } else {
        toast.error(res?.data?.message);
        setloaderApi(false);
      }
    });
  };
  const openChat = () => {
    const iframe = document.getElementById("chat-widget-minimized");
    const iframeDocument =
      iframe.contentDocument || iframe.contentWindow.document;
    const iframeButton = iframeDocument.getElementsByClassName("e1mwfyk10")[0];
    if (iframeButton) {
      iframeButton.click();
    } else {
      console.error("Button inside iframe not found.");
    }
  };
  const HandleStoneQuality = (v) => {
    let replaceUrl =
      "/product-detail/" +
      productdetail?.group_id +
      "/" +
      productdetail?.slug +
      "/" +
      encodeURIComponent(v);

    navigate(
      replaceUrl,
      {
        replace: true,
      }
    );
    // setSelectedStoneQlty(v);
    // setSearchParams({ stone_quality: v });
  };
  // const HandleStoneQuality = (v) => {
  //   let replaceUrl =
  //     "/product-detail/" +
  //     productdetail?.group_id +
  //     "/" +
  //     productdetail?.slug + "/" + v.replaceAll("+/", "%2B%2F")
  //   navigate(
  //     replaceUrl,
  //     {
  //       replace: true,
  //     }
  //   );
  //   // setSelectedStoneQlty(v);
  //   // setSearchParams({ stone_quality: v });
  // };


  const indexHandleResponsive = (array) => {
    if (array.length > 0) {
      const title = "Metal";
      const indexMetal = array.findIndex((val) => val.title === title);
      if (screenWidth < 767) {
        const [movedItem] = array.splice(indexMetal, 1);
        array.splice(0, 0, movedItem); // this will move to top
        return array;
      } else {
        return array;
      }
    }
  };
  useEffect(() => {
    if (klevuclicked) {
      productdetailapi(group_id, slug, stone_quality);
    }
    dispatch(clickklevu(false));
  }, [klevuclicked]);
  // useEffect(() => {

  //   const addSwiperJS = () => {
  //     const parentElement = document.querySelector('.centerstonecaratweight1');
  //     let childHasClass= parentElement.querySelector('.swiper-button-lock');

  //     if (childHasClass) {
  //       parentElement.classList.add('navigationLock');
  //     }
  //   }
  //   window.addEventListener('load', addSwiperJS);
  //   return () => {
  //     window.removeEventListener('load', addSwiperJS);
  //   };
  // }, [productdetail]);


  return (
    <>

      <Helmet>
        <meta charSet="utf-8" />
        <title>{metaData?.meta_title}</title>
        <meta
          name="description"
          content={metaData?.meta_description}
        ></meta>
        <meta name="keywords" content={metaData?.meta_keywords}></meta>
        <script>
          {`
          window._affirm_config = {
            public_api_key: "C43KC6BBHCNCVPUM",
            script: "https://cdn1.affirm.com/js/v2/affirm.js"
          };
        `}
        </script>

        <script type="application/ld+json">
          {`
        {
          "@context": "https://schema.org/",
          "@type": "Product",
          "name": ${productdetail?.name},
          "image": ${productdetail?.product_image?.[0]?.url},
          "description": ${productdetail?.meta_description},
          "sku": ${productdetail?.sku},
          "brand": {
            "@type": "Brand",
            "name": ${productdetail?.category_name}
          },
          "offers": {
            "@type": "Offer",
            "url": ${productdetail?.product_image?.[0]?.url},
            "priceCurrency": ${productdetail?.currency},
            "price": ${productdetail?.price},
            "itemCondition": "https://schema.org/NewCondition",
            "availability": ${productdetail?.is_in_stock}
          },
          "aggregateRating": {
            "@type": "AggregateRating",
            "ratingValue": "4.8",
            "reviewCount": "24"
          }
        }
      `}
        </script>

        <script type="application/ld+json">
          {`
    {
"@context": "https://schema.org",
"@type": "BreadcrumbList",
"itemListElement": [
{
"@type": "ListItem",
"position": 1,
"name": "Home",
"item": ${img_url}
},
{
"@type": "ListItem",
"position": 2,
"name": ${productdetail?.category_name},
"item": ${img_url.replace(/\/$/, "") + detailSlug}
},
{
"@type": "ListItem",
"position": 3,
"name": ${productdetail?.name}
}
]
}
    `}

        </script>

        {/* Load the external Affirm script */}
        <script src="https://cdn1.affirm.com/js/v2/affirm.js" async></script>
      </Helmet>
      <Container className="pdp_breadcrumb">
        <Breadcrumb className="mb-3">
          <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
          <Breadcrumb.Item href={detailSlug}>
            {productdetail?.category_name}
          </Breadcrumb.Item>
          <Breadcrumb.Item active>{productdetail?.name}</Breadcrumb.Item>
        </Breadcrumb>
      </Container>

      <ToastContainer />
      <section className="single_product_section">
        <Container fluid>
          {loader2 ? (
            <Single_product_skeleton />
          ) : (
            <Row>
              <Col
                className="product-detail-img-box p-0 position-relative"
                md={12}
                lg={7}
                sm={12}
              >
                {screenWidth < 767 && (
                  <span
                    className="pointer overlapView"
                    onClick={() => {
                      add_to_wishlist(
                        productdetail?.group_id,
                        productdetail?.product_id
                      );
                      if (productdetail?.is_wishlist) {
                        kleviyoRemoveWishlist(productdetail, "no");
                      } else {
                        klaviyo_Wishlist(productdetail, "yes");
                      }
                    }}
                  >
                    {productdetail?.is_wishlist ? (
                      <span>
                        {/* <AiFillHeart /> */}
                        <img
                          style={{ width: "22px" }}
                          src={
                            s3_img_url + "product_list/heart-fill-new.svg"
                          }
                          alt=""
                        />
                      </span>
                    ) : (
                      <span className="ml-3">
                        <img
                          style={{ width: "22px" }}
                          src={
                            s3_img_url + "product_list/heart-state-1.svg"
                          }
                          alt=""
                        />
                      </span>
                    )}
                  </span>
                )}

                <div className="product_img_box mobile_hide">
                  {productdetail?.product_image?.map((item, index) =>
                    item?.type == "1" ? (
                      // <img src={item.url} />
                      <div className="innerImgbox">
                        {index == 0 ? (
                          <>
                            {/* <span className="overlay-top-left-text">
                            {productdetail?.overlay_top_left}
                          </span> */}
                            <span className="overlay-bottom-center-text">
                              {productdetail?.overlay_bottom}
                            </span>
                          </>
                        ) : (
                          ""
                        )}
                        <InnerImageZoom src={item.url} zoomSrc={item.url} imgAttributes={{ alt: productdetail?.name }} />
                      </div>
                    ) : (
                      // <video
                      //   width="412"
                      //   height="412"
                      //   src={item.url}
                      //   frameBorder="0"
                      //   allowFullScreen={true}
                      //   autoplay={true} muted={true} loop={true}
                      // >
                      //     <source src={item?.url} type="video/mp4"/>
                      // </video>
                      // <VideoPlayer
                      // width="412"
                      // height="412"
                      // src={item?.url}

                      // />
                      <Player
                        // video player change Start
                        key={item?.url}
                        // video player change End
                        className="videoWrap"
                        width={412}
                        height={412}
                        muted={true}
                        playsInline={true}
                        autoPlay={true}
                        loop={true}
                        controls={false}
                      >
                        <source src={item?.url} />
                      </Player>
                    )
                  )}
                </div>
                {/* From Mobile Screen */}
                <div className="product_img_box desktop_hide">
                  <Swiper
                    pagination={true} modules={[Pagination]} className="mySwiper"
                  >
                    {productdetail?.product_image?.map(
                      (item, index) => (
                        // item?.type == "1" ? (
                        // <GalleryImage url={item?.url} itemType={item?.type}/>
                        // <img className="img-fluid" src={item?.url} alt="Weddign Day Diamonds" />
                        // ) : (
                        // <video
                        //   width="300"
                        //   height="300"
                        //   src={item.url}
                        //   frameBorder="0"
                        //   allowFullScreen={true}
                        //   autoplay={true} muted={true} loop={true}
                        // >
                        //   <source src={item?.url} type="video/mp4"/>
                        // </video>

                        // video player change start
                        <SwiperSlide>
                          <VideoComponent
                            url={item?.url}
                            itemType={item?.type}
                          />
                        </SwiperSlide>
                      )
                      // video player change End
                      // )
                    )}
                  </Swiper>
                  <div className="mobileinnerImgbox">
                    <span className="overlay-top-left-text">
                      {productdetail?.overlay_top_left}
                    </span>
                    <span className="overlay-bottom-center-text">
                      {productdetail?.overlay_bottom}
                    </span>
                  </div>
                </div>
              </Col>
              <Col
                className="product-detail-content-box"
                md={12}
                lg={5}
                sm={12}
              >
                <Form className="product_text_box_upper">
                  <div className="product_text_box">
                    <div className="">
                      <h1 className="single_product_title d-flex justify-content-between">
                        <span>{productdetail?.name}</span>

                        {screenWidth > 767 && (
                          <span
                            className="pointer"
                            onClick={() => {
                              add_to_wishlist(
                                productdetail?.group_id,
                                productdetail?.product_id
                              );
                              if (productdetail?.is_wishlist) {
                                kleviyoRemoveWishlist(productdetail, "no");
                              } else {
                                klaviyo_Wishlist(productdetail, "yes");
                              }
                            }}
                          >
                            {productdetail?.is_wishlist ? (
                              <span>
                                {/* <AiFillHeart /> */}
                                <img
                                  style={{ width: "22px" }}
                                  src={
                                    s3_img_url + "product_list/heart-fill-new.svg"
                                  }
                                  alt=""
                                />
                              </span>
                            ) : (
                              <span className="ml-3">
                                <img
                                  style={{ width: "22px" }}
                                  src={
                                    s3_img_url + "product_list/heart-state-1.svg"
                                  }
                                  alt=""
                                />
                              </span>
                            )}
                          </span>
                        )}
                      </h1>
                      <div className="logos manageH">
                        {
                          productdetail?.made_in_usa === "yes" && <img src={s3_img_url + 'product_list/logo1.svg'} alt="Made in USA" />
                        }
                        {
                          productdetail?.recycled_metals === "yes" && <img src={s3_img_url + 'product_list/logo2.svg'} alt="Recycled Metals" />
                        }

                        {
                          productdetail?.is_show_ring_icon == "1" &&
                          <div className="info_hoverbox metalRecycle">
                            <img
                              src={s3_img_url + "recycle_icon_blue.png"}
                              className="metalTrigger"
                              alt="Recycled Metals Blue"
                            />
                            <div className="center_stone_info_hoverbox">
                              <div className="center_stone_inner-box">
                                <div className="d-flex align-items-center justify-content-center mx-auto col-lg-9">
                                  <div style={{ marginRight: "20px" }}>
                                    <img
                                      className="img-fluid innerH"
                                      src={s3_img_url + "PerfectRingPromise_Final-06.png"}
                                      alt="WORRY-FREE DIAMOND SELECTION"
                                    />
                                  </div>
                                  <div className="text-start">
                                    <h2>
                                      WHY CHOOSE A WEDDING DAY DIAMONDS RING?
                                    </h2>
                                  </div>
                                </div>
                                <p>
                                  Most rings sold online are made to be
                                  delicate, designed for style & price, but not
                                  made to last. These same rings are also sold
                                  by online jewelers that want you to purchase
                                  an extended warranty which will only last for
                                  a few years. At Wedding Day Diamonds, we
                                  custom design and manufacture each ring to
                                  last a lifetime with no risk to you on future
                                  repairs or damage. All engagement rings come
                                  with our Free No Fine Print Lifetime Warranty
                                  and a 365 Day Perfect Ring Promise. No
                                  inspections required, ever.
                                </p>
                              </div>
                            </div>
                          </div>
                        }

                      </div>
                      <p className="single_pro_price desktop_hide">
                        {Number(
                          productdetail?.original_price.replaceAll(",", "")
                        ) !=
                          Number(productdetail?.price.replaceAll(",", "")) ? (
                          <>
                            <span className="sl_price_color mr5">
                              <del>
                                {productdetail?.currency +
                                  productdetail?.original_price}{" "}
                              </del>
                            </span>
                            {productdetail?.currency}
                            {productdetail?.price}
                          </>
                        ) : (
                          <div className="single_pro_price_black">
                            {productdetail?.currency}
                            {productdetail?.original_price}
                          </div>
                        )}
                        {/* <del>{productdetail?.original_price != productdetail?.price ? <span>{productdetail?.currency}{productdetail?.original_price} </span> : ""} {productdetail?.currency}{productdetail?.price}</del> */}
                      </p>
                      <p className="single_product_cat mobile_hide">
                        {productdetail?.collection}
                      </p>
                      <p className="single_product_des mobile_hide">
                        {productdetail?.description?.length ? (
                          <LongText
                            content={productdetail?.description}
                            limit={100}
                          />
                        ) : (
                          ""
                        )}
                      </p>
                    </div>

                    {screenWidth > 1199 && (
                      <p className="single_pro_price mobile_hide d-flex align-items-center">
                        {Number(
                          productdetail?.original_price.replaceAll(",", "")
                        ) !=
                          Number(productdetail?.price.replaceAll(",", "")) ? (
                          <>
                            <span className="sl_price_color mr5">
                              <del>
                                {productdetail?.currency +
                                  productdetail?.original_price}{" "}
                              </del>
                            </span>
                            {productdetail?.currency}

                            {productdetail?.price}
                          </>
                        ) : (
                          <div className="single_pro_price_black">
                            {productdetail?.currency}
                            {productdetail?.original_price}
                          </div>
                        )}
                      </p>
                    )}
                    <p className="single_pro_loan mb-4">
                      <p
                        className="affirm-as-low-as"
                        data-page-type="category"
                        data-amount={
                          Number(productdetail?.price?.replaceAll(",", "")) *
                          100
                        }
                      ></p>
                    </p>




                    {indexHandleResponsive(filterdetail)?.map((val, ind) =>

                      val?.title != "Ring Size" ? (
                        <>
                          <div
                            className={
                              val?.title == "Side Stone Carat Total Weight" ||
                                val?.title == "Center Stone Carat Weight" ||
                                val?.title == "Diamond Carat Weight"
                                ? "single_filter_box ctw"
                                : "single_filter_box"
                            }
                            key={val?.id}
                          >
                            <h3 className="single_filter_title">
                              {val?.title}
                              {val?.title == "Center Stone Carat Weight" ? (
                                ""
                              ) : (val?.title == "Metal" || val?.title == "Gemstone Type") ? (
                                <>
                                  <span className="selected_data">
                                    (
                                    {
                                      val?.data?.filter(
                                        (val1) => val?.selected == val1.value
                                      )[0]?.name
                                    }
                                    )
                                  </span>
                                </>
                              ) : (
                                ""
                              )}
                            </h3>

                            {val?.data?.length > 5 ? (
                              <div
                                className={
                                  `${"center_stone_box" +
                                  ind +
                                  " " +
                                  val.title
                                    .replaceAll(" ", "")
                                    .toLowerCase() +
                                  ind
                                  } ` +
                                  (val?.title).split(" ").join("_") +
                                  "_detaile_filter center_stone_box"
                                }
                              >

                                <Swiper
                                  initialSlide={val?.title == "Diamond Carat Weight" && Math.max(0, val?.selected.replace(/\D/g, '') - Math.floor(8 / 2))}
                                  // navigation={true}
                                  loop={false}
                                  navigation={{
                                    nextEl: '.swiper-button-next',
                                    prevEl: '.swiper-button-prev',
                                  }}
                                  spaceBetween={5}
                                  slidesPerView={8}
                                  freeMode={false}
                                  pagination={{
                                    clickable: false,
                                  }}
                                  modules={[Navigation]}
                                  className={`mySwiper1 `}
                                  breakpoints={{
                                    300: {
                                      // width: 576,
                                      slidesPerView: 5,
                                    },
                                    600: {
                                      // width: 576,
                                      slidesPerView: 5,
                                    },
                                    1024: {
                                      // width: 768,
                                      slidesPerView: 6,
                                    },
                                    1100: {
                                      // width: 768,
                                      slidesPerView: 8,
                                    },



                                  }}
                                >



                                  {val?.data?.map((val1, idx) => (
                                    <SwiperSlide>
                                      <div className="item-data uniq">
                                        <ToggleButton
                                          key={idx}
                                          id={`${val1?.name}-${idx}`}
                                          type="radio"
                                          variant={"outline-defult"}
                                          name={val1?.name}
                                          value={val?.selected}
                                          checked={val?.selected == val1?.value}
                                        >
                                          {val1?.icon ? (
                                            // <img alt=""
                                            //   height={60}
                                            //   src={val1?.icon}
                                            //   onClick={() =>
                                            //     onchangeselect(val1?.value, val?.title)
                                            //   }
                                            // />
                                            <OverlayTrigger
                                              overlay={(props) => (
                                                <Tooltip {...props}>
                                                  {val1?.name}
                                                </Tooltip>
                                              )}
                                              placement="top"
                                            >
                                              {val1.icon?.length ? (
                                                <img
                                                  alt={val1?.name}
                                                  title={val1?.name}
                                                  height={60}
                                                  src={val1?.icon}
                                                  onClick={() =>
                                                    onchangeselect(
                                                      val1?.value,
                                                      val?.title
                                                    )
                                                  }
                                                />
                                              ) : val?.title == "Metal" ? (
                                                <div className="metal_box_noimg">
                                                  {String(
                                                    val1.name
                                                      .split(" ")
                                                      .slice(0, 1)
                                                  ).slice(0, 1)}
                                                  {String(
                                                    val1.name
                                                      .split(" ")
                                                      .slice(1, 2)
                                                  ).slice(0, 1)}
                                                </div>
                                              ) : (
                                                ""
                                              )}
                                            </OverlayTrigger>
                                          ) : (
                                            <span
                                              onClick={() =>
                                                onchangeselect(
                                                  val1?.value,
                                                  val?.title
                                                )
                                              }
                                            >
                                              {val1?.name}
                                            </span>
                                          )}
                                        </ToggleButton>
                                      </div>
                                    </SwiperSlide>
                                  ))}
                                  <div className="swiper-button-prev">
                                    <svg xmlns="http://www.w3.org/2000/svg" height="40px" viewBox="0 -960 960 960" width="40px" fill="#bfbfbf"><path d="M400-80 0-480l400-400 61 61.67L122.67-480 461-141.67 400-80Z" /></svg>
                                  </div>
                                  <div className="swiper-button-next">
                                    <svg xmlns="http://www.w3.org/2000/svg" height="40px" viewBox="0 -960 960 960" width="40px" fill="#bfbfbf"><path d="m309.67-81.33-61-61.67L587-481.33 248.67-819.67l61-61.66 400 400-400 400Z" /></svg>
                                  </div>
                                </Swiper>

                              </div>
                            ) : (
                              <Slider
                                {...settings_1}
                                className={
                                  (val?.title).split(" ").join("_") +
                                  "_detail_filter"
                                }
                              >
                                {val?.data?.map((val1, idx) => (
                                  <div className="item-data">
                                    <ToggleButton
                                      key={idx}
                                      id={`${val1?.name}-${idx}`}
                                      type="radio"
                                      variant={"outline-defult"}
                                      name={val1?.name}
                                      value={val?.selected}
                                      checked={val?.selected == val1?.value}
                                    >
                                      {val1?.icon ? (
                                        <OverlayTrigger
                                          overlay={(props) => (
                                            <Tooltip {...props}>
                                              {val1?.name}
                                            </Tooltip>
                                          )}
                                          placement="top"
                                        >
                                          {val1.icon?.length ? (
                                            <img
                                              alt={val1?.name}
                                              title={val1?.name}
                                              height={60}
                                              src={val1?.icon}
                                              onClick={() =>
                                                onchangeselect(
                                                  val1?.value,
                                                  val?.title
                                                )
                                              }
                                            />
                                          ) : val?.title == "Metal" ? (
                                            <div className="metal_box_noimg">
                                              {String(
                                                val1.name.split(" ").slice(0, 1)
                                              ).slice(0, 1)}
                                              {String(
                                                val1.name.split(" ").slice(1, 2)
                                              ).slice(0, 1)}
                                            </div>
                                          ) : (
                                            ""
                                          )}
                                        </OverlayTrigger>
                                      ) : (
                                        <span
                                          onClick={() =>
                                            onchangeselect(
                                              val1?.value,
                                              val?.title
                                            )
                                          }
                                        >
                                          {val1?.name}
                                        </span>
                                      )}
                                    </ToggleButton>
                                  </div>
                                ))}
                              </Slider>
                            )}
                          </div>

                          {val?.title == "Center Stone Carat Weight" &&
                            productdetail?.stone_quality.length > 0 && (
                              <div className="stoneQuality mt-2 mb-2">
                                <h3 className="single_filter_title">
                                  Diamond Quality{" "}
                                  <div className="info_hoverbox metalRecycle">
                                    <img
                                      src={s3_img_url + "product_list/centerston.png"}
                                      className="metalTrigger widthHandle"
                                      alt="Recycled Metals Blue"
                                    />
                                    <div className="center_stone_info_hoverbox">
                                      <div className="center_stone_inner-box">
                                        <img
                                          src={s3_img_url + 'product_list/worry-free.png'}
                                          alt="WORRY-FREE DIAMOND SELECTION"
                                        />
                                        <h2>WORRY-FREE DIAMOND SELECTION</h2>
                                        <p className="text-capitalize1">
                                          At Wedding Day Diamonds, you can
                                          safely buy your diamond sight unseen.
                                          How? Because unlike other jewelers who
                                          choose the cheapest lab-grown
                                          diamonds, we choose only the best.
                                          Your custom-made ring will be paired
                                          with the highest quality lab-grown
                                          diamond available and is guaranteed to
                                          have a minimum rating within the
                                          diamond quality category you choose.
                                          If we find a diamond with even higher
                                          ratings, we include it at no extra
                                          charge.
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </h3>
                                <div
                                  className={`${screenWidth < 991 &&
                                    "justify-content-center"
                                    } d-flex flex-wrap`}
                                >
                                  {productdetail?.stone_quality.length > 0 &&
                                    productdetail?.stone_quality.map((e, i) => (
                                      <div
                                        className={`${e?.selected ? "selected" : ""
                                          } item-data`}
                                      >
                                        <input
                                          className="d-none"
                                          id={`${i + e?.label}`}
                                          type="radio"
                                          name="stone_quality"
                                        />
                                        <label
                                          htmlFor={`${i + e?.label}`}
                                          className={` `}
                                          onClick={() =>
                                            HandleStoneQuality(e?.label)
                                          }
                                        >
                                          {e?.label}
                                        </label>
                                      </div>
                                    ))}
                                </div>
                              </div>
                            )}
                        </>
                      ) : (
                        <>
                          <div className="single_filter_select_box">
                            <Row className="m-0">
                              <Col md={5} lg={5} sm={12} className="p-0">
                                <h3 className="single_filter_title pb-2 mb-0">
                                  {val?.title}
                                  <Link
                                    className="SizeGuide text-capitalize"
                                    to={s3_img_url + 'RingSizeChart_Final.pdf'}
                                    target="_blank"
                                  >
                                    Size Guide
                                  </Link>
                                </h3>
                                <Form.Select
                                  className={`ringSizeSel ${isringsize == true ? "notselect" : ""
                                    }`}
                                  onBlur={() => setIsringsize(!true)}
                                  value={customField ? "Custom" : ringsize}
                                  onChange={(e) => {
                                    if (e.target.value == "Custom") {
                                      setCustomField(true);
                                      setRingsize("");
                                    } else {
                                      setRingsize(e.target.value);
                                      setCustomField(false);
                                    }
                                  }}
                                >
                                  <option
                                    value=""
                                    selected
                                    disabled
                                    className="placeholder"
                                  >
                                    Select
                                  </option>
                                  {val?.data?.map((val1) => (
                                    <option value={val1?.value}>
                                      {val1?.name}
                                    </option>
                                  ))}
                                </Form.Select>
                                {customField ? (
                                  <Form.Group>
                                    <Form.Control
                                      onChange={(e) =>
                                        e.target.value > 0 &&
                                          e.target.value < 100
                                          ? setRingsize(e.target.value)
                                          : ""
                                      }
                                      value={ringsize}
                                      type="number"
                                      placeholder="Enter Your Ring Size"
                                    />
                                  </Form.Group>
                                ) : (
                                  ""
                                )}
                              </Col>
                              {productdetail?.enable_engraving == "1" ? (
                                <Col md={7} lg={7} sm={12} className="p-0">
                                  <h3 className="single_filter_title d-flex pb-0 mb-0 engMob flex-wrap openerTitle">
                                    ENGRAVING
                                    <span>
                                      (+ {productdetail?.currency}
                                      {productdetail?.engraving_charges})
                                    </span>
                                    <Form.Check
                                      className="d-flex align-items-center"
                                      name="yes"
                                      type="radio"
                                      label="Yes"
                                      aria-label="yes"
                                      checked={is_engraving == 1}
                                      onClick={() => {
                                        setIs_engraving(1);
                                        setfontFamily("Times New Roman");
                                      }}
                                    />
                                    <Form.Check
                                      className="d-flex align-items-center"
                                      name="no"
                                      type="radio"
                                      label="No"
                                      aria-label="no"
                                      checked={is_engraving == 0}
                                      onClick={() => {
                                        setIs_engraving(0);
                                        setfontFamily("");
                                        setIsEngravingHas(false);
                                      }}
                                    />
                                  </h3>
                                  {is_engraving ? (
                                    <Form.Group
                                      controlId="formBasicEmail"
                                      className="mb-2"
                                    >
                                      <Form.Control
                                        className={
                                          isEngravingHas == true
                                            ? "notselectEngraving mb-3"
                                            : "mb-2"
                                        }
                                        // onBlur={() => setIsEngravingHas(!true)}
                                        onChange={(e) =>
                                          setEngravingtext(e.target.value)
                                        }
                                        value={engravingtext}
                                        type="text"
                                        maxLength={15}
                                        placeholder="Limit 15 Characters"
                                        required
                                      />

                                      <Dropdown className="designFontScript">
                                        <Dropdown.Toggle
                                          variant="success"
                                          id="dropdown-basic"
                                          className={
                                            fontFamily === "Times New Roman"
                                              ? "timesNewRoman"
                                              : "scrMjBold"
                                          }
                                        >
                                          {fontFamily}
                                        </Dropdown.Toggle>

                                        <Dropdown.Menu>
                                          <Dropdown.Item
                                            className="timesNewRoman"
                                            onClick={() =>
                                              setfontFamily("Times New Roman")
                                            }
                                            href="javascript:void(0)"
                                          >
                                            Times New Roman

                                          </Dropdown.Item>
                                          <Dropdown.Item
                                            className="scrMjBold"
                                            onClick={() =>
                                              setfontFamily("Script MT Bold")
                                            }
                                            href="javascript:void(0)"
                                          >
                                            Script MT Bold

                                          </Dropdown.Item>
                                        </Dropdown.Menu>
                                      </Dropdown>
                                    </Form.Group>
                                  ) : (
                                    ""
                                  )}
                                </Col>
                              ) : (
                                ""
                              )}
                            </Row>
                          </div>
                        </>
                      )
                    )}
                    {screenWidth < 1199 && (
                      <>
                        <p className="single_pro_price mobile_hide">
                          {Number(
                            productdetail?.original_price.replaceAll(",", "")
                          ) !=
                            Number(productdetail?.price.replaceAll(",", "")) ? (
                            <>
                              <span className="sl_price_color mr5">
                                <del>
                                  {productdetail?.currency +
                                    productdetail?.original_price}
                                </del>
                              </span>
                              {productdetail?.currency}

                              {productdetail?.price}
                            </>
                          ) : (
                            <div className="single_pro_price_black">
                              {productdetail?.currency}
                              {productdetail?.original_price}
                            </div>
                          )}
                        </p>
                      </>
                    )}

                    {/* Starting at $195/mo with <img src={affirm} alt="affirm" />{" "}
                      <Link to="#" className="">
                        Prequalify now
                      </Link> */}

                    <article className="warrantySection px-3 py-4 px-lg-4 mt-2">
                      <div
                        dangerouslySetInnerHTML={{
                          __html: warranyContent?.heading,
                        }}
                      ></div>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: warranyContent?.content,
                        }}
                      ></div>
                    </article>
                    <div className="d-flex flex-wrap align-items-center my-3">
                      <span className="busShip">{shippingBus}</span>
                      <p className="single_pro_shippingdate mb-0">
                        {productdetail?.shipment_label}
                      </p>
                      <button
                        type="button"
                        className="btn link needFaster"
                        onClick={openChat}
                      >
                        Need it faster?
                      </button>
                    </div>

                    {
                      shippingAlert && shippingAlert.length > 0 &&
                      <div className="shipMsg mb-3">
                        {shippingAlert.length > 0 && shippingAlert?.map((e, i) => (
                          <p key={i} className="fw700 colorRed  fs13 ls1 d-flex align-items-center mb-1">
                            {/* <img src={s3_img_url+ "ai.png"} alt="shipping date" className="img-fluid mr6" /> */}
                            <div dangerouslySetInnerHTML={{
                              __html: e?.alert_text
                            }} />
                          </p>
                        ))
                        }
                      </div>
                    }



                    <section className="mb-3">
                      {productdetail?.offer_product?.length
                        ? productdetail?.offer_product.map(
                          (e, i) =>
                            i == 0 && (
                              <div className="single_pro_offer_pro" key={i}>
                                <img src={e?.img} alt="Diamond" />
                                <p
                                  style={{ cursor: "pointer" }}
                                  onClick={() => {
                                    handleShowMore(e);
                                    freeGift_handleShow();
                                  }}
                                  dangerouslySetInnerHTML={{
                                    __html:
                                      productdetail?.offer_product[0]?.name.replace(
                                        /Free/g,
                                        "<b>Free</b>"
                                      ),
                                  }}
                                />
                              </div>
                            )
                        )
                        : ""}
                    </section>

                    {productdetail?.is_in_stock ? (
                      <button
                        className="theme_btn_light bg_theme"
                        onClick={(e) =>
                          add_to_cart(e, productdetail?.product_id)
                        }
                      >
                        Add to Cart
                      </button>
                    ) : (
                      <button
                        className="theme_btn_light bg_theme"
                        disabled
                        style={{ opacity: 0.5 }}
                      >
                        Out of Stock
                      </button>
                    )}
                    <ul className="single_pro_listbtn">
                      <li onClick={() => setToggle(!toggle)}>
                        <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 1024 1024" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M752 664c-28.5 0-54.8 10-75.4 26.7L469.4 540.8a160.68 160.68 0 0 0 0-57.6l207.2-149.9C697.2 350 723.5 360 752 360c66.2 0 120-53.8 120-120s-53.8-120-120-120-120 53.8-120 120c0 11.6 1.6 22.7 4.7 33.3L439.9 415.8C410.7 377.1 364.3 352 312 352c-88.4 0-160 71.6-160 160s71.6 160 160 160c52.3 0 98.7-25.1 127.9-63.8l196.8 142.5c-3.1 10.6-4.7 21.8-4.7 33.3 0 66.2 53.8 120 120 120s120-53.8 120-120-53.8-120-120-120zm0-476c28.7 0 52 23.3 52 52s-23.3 52-52 52-52-23.3-52-52 23.3-52 52-52zM312 600c-48.5 0-88-39.5-88-88s39.5-88 88-88 88 39.5 88 88-39.5 88-88 88zm440 236c-28.7 0-52-23.3-52-52s23.3-52 52-52 52 23.3 52 52-23.3 52-52 52z"></path></svg>
                        SHARE
                        {toggle && (
                          <div className="socialmediaIconBox">
                            <FacebookShareButton
                              url={String(window.location.href)}
                              className="Demo__some-network__share-button"
                            >
                              <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 512 512" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M504 256C504 119 393 8 256 8S8 119 8 256c0 123.78 90.69 226.38 209.25 245V327.69h-63V256h63v-54.64c0-62.15 37-96.48 93.67-96.48 27.14 0 55.52 4.84 55.52 4.84v61h-31.28c-30.8 0-40.41 19.12-40.41 38.73V256h68.78l-11 71.69h-57.78V501C413.31 482.38 504 379.78 504 256z"></path></svg>
                            </FacebookShareButton>

                            <PinterestShareButton
                              url={String(window.location.href)}
                              media={String(window.location.href)}
                              windowWidth={1000}
                              windowHeight={730}
                            >
                              <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 496 512" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M496 256c0 137-111 248-248 248-25.6 0-50.2-3.9-73.4-11.1 10.1-16.5 25.2-43.5 30.8-65 3-11.6 15.4-59 15.4-59 8.1 15.4 31.7 28.5 56.8 28.5 74.8 0 128.7-68.8 128.7-154.3 0-81.9-66.9-143.2-152.9-143.2-107 0-163.9 71.8-163.9 150.1 0 36.4 19.4 81.7 50.3 96.1 4.7 2.2 7.2 1.2 8.3-3.3.8-3.4 5-20.3 6.9-28.1.6-2.5.3-4.7-1.7-7.1-10.1-12.5-18.3-35.3-18.3-56.6 0-54.7 41.4-107.6 112-107.6 60.9 0 103.6 41.5 103.6 100.9 0 67.1-33.9 113.6-78 113.6-24.3 0-42.6-20.1-36.7-44.8 7-29.5 20.5-61.3 20.5-82.6 0-19-10.2-34.9-31.4-34.9-24.9 0-44.9 25.7-44.9 60.2 0 22 7.4 36.8 7.4 36.8s-24.5 103.8-29 123.2c-5 21.4-3 51.6-.9 71.2C65.4 450.9 0 361.1 0 256 0 119 111 8 248 8s248 111 248 248z"></path></svg>
                            </PinterestShareButton>
                            <TwitterShareButton
                              title={"Wedding Day Diamonds"}
                              url={String(window.location.href)}
                            >
                              <svg
                                fill="#395754"
                                viewBox="0 0 24 24"
                                aria-label="X"
                                role="img"
                                className="r-18jsvk2 r-4qtqp9 r-yyyyoo r-16y2uox r-lwhw9o r-dnmrzs r-bnwqim r-1plcrui r-lrvibr"
                              >
                                <g>
                                  <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"></path>
                                </g>
                              </svg>
                            </TwitterShareButton>

                            <EmailShareButton
                              subject={"Wedding Day Diamonds"}
                              body={String(window.location.href)}
                              separator={separator}
                            >
                              <svg style={{ height: "22px" }} stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 512 512" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M460.6 147.3L353 256.9c-.8.8-.8 2 0 2.8l75.3 80.2c5.1 5.1 5.1 13.3 0 18.4-2.5 2.5-5.9 3.8-9.2 3.8s-6.7-1.3-9.2-3.8l-75-79.9c-.8-.8-2.1-.8-2.9 0L313.7 297c-15.3 15.5-35.6 24.1-57.4 24.2-22.1.1-43.1-9.2-58.6-24.9l-17.6-17.9c-.8-.8-2.1-.8-2.9 0l-75 79.9c-2.5 2.5-5.9 3.8-9.2 3.8s-6.7-1.3-9.2-3.8c-5.1-5.1-5.1-13.3 0-18.4l75.3-80.2c.7-.8.7-2 0-2.8L51.4 147.3c-1.3-1.3-3.4-.4-3.4 1.4V368c0 17.6 14.4 32 32 32h352c17.6 0 32-14.4 32-32V148.7c0-1.8-2.2-2.6-3.4-1.4z"></path><path d="M256 295.1c14.8 0 28.7-5.8 39.1-16.4L452 119c-5.5-4.4-12.3-7-19.8-7H79.9c-7.5 0-14.4 2.6-19.8 7L217 278.7c10.3 10.5 24.2 16.4 39 16.4z"></path></svg>
                            </EmailShareButton>

                            {/* <MdOutlineSms style={{height: "18px"}} /> */}
                          </div>
                        )}
                      </li>
                      <li
                        onClick={() => {
                          add_to_wishlist(
                            productdetail?.group_id,
                            productdetail?.product_id
                          );
                          if (productdetail?.is_wishlist) {
                            kleviyoRemoveWishlist(productdetail, "no");
                          } else {
                            klaviyo_Wishlist(productdetail, "yes");
                          }
                        }}
                      >
                        {productdetail?.is_wishlist ? (
                          <span>
                            {/* <AiFillHeart /> */}
                            <img
                              style={{ width: "22px" }}
                              src={
                                s3_img_url + "product_list/heart-fill-new.svg"
                              }
                              alt=""
                            />
                            REMOVE FROM WISHLIST
                          </span>
                        ) : (
                          <span>
                            <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 1024 1024" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M923 283.6a260.04 260.04 0 0 0-56.9-82.8 264.4 264.4 0 0 0-84-55.5A265.34 265.34 0 0 0 679.7 125c-49.3 0-97.4 13.5-139.2 39-10 6.1-19.5 12.8-28.5 20.1-9-7.3-18.5-14-28.5-20.1-41.8-25.5-89.9-39-139.2-39-35.5 0-69.9 6.8-102.4 20.3-31.4 13-59.7 31.7-84 55.5a258.44 258.44 0 0 0-56.9 82.8c-13.9 32.3-21 66.6-21 101.9 0 33.3 6.8 68 20.3 103.3 11.3 29.5 27.5 60.1 48.2 91 32.8 48.9 77.9 99.9 133.9 151.6 92.8 85.7 184.7 144.9 188.6 147.3l23.7 15.2c10.5 6.7 24 6.7 34.5 0l23.7-15.2c3.9-2.5 95.7-61.6 188.6-147.3 56-51.7 101.1-102.7 133.9-151.6 20.7-30.9 37-61.5 48.2-91 13.5-35.3 20.3-70 20.3-103.3.1-35.3-7-69.6-20.9-101.9zM512 814.8S156 586.7 156 385.5C156 283.6 240.3 201 344.3 201c73.1 0 136.5 40.8 167.7 100.4C543.2 241.8 606.6 201 679.7 201c104 0 188.3 82.6 188.3 184.5 0 201.2-356 429.3-356 429.3z"></path></svg>
                            ADD TO WISHLIST
                          </span>
                        )}
                      </li>
                      <li
                        onClick={() => {
                          setDrophintimg(productdetail?.product_image[0].url);
                          handleShow();
                        }}
                      >
                        <svg stroke="currentColor" fill="currentColor" strokeWidth="0" t="1569683742680" viewBox="0 0 1024 1024" version="1.1" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><defs></defs><path d="M931.4 498.9L94.9 79.5c-3.4-1.7-7.3-2.1-11-1.2-8.5 2.1-13.8 10.7-11.7 19.3l86.2 352.2c1.3 5.3 5.2 9.6 10.4 11.3l147.7 50.7-147.6 50.7c-5.2 1.8-9.1 6-10.3 11.3L72.2 926.5c-0.9 3.7-0.5 7.6 1.2 10.9 3.9 7.9 13.5 11.1 21.5 7.2l836.5-417c3.1-1.5 5.6-4.1 7.2-7.1 3.9-8 0.7-17.6-7.2-21.6zM170.8 826.3l50.3-205.6 295.2-101.3c2.3-0.8 4.2-2.6 5-5 1.4-4.2-0.8-8.7-5-10.2L221.1 403 171 198.2l628 314.9-628.2 313.2z"></path></svg>
                        SEND A HINT
                      </li>
                    </ul>
                    <div className="my-3">
                      <img
                        className="w-100"
                        src={s3_img_url + "product_list/store.jpg"}
                        alt="BOOK AN APPOINTMENT"
                      />
                    </div>

                    <div className="w-100 mb-4 mt-3">
                      <Link
                        onClick={bookAppointment_handleShow}
                        className="d-flex align-items-center text-center appointment_box justify-content-center w-100"
                      >
                        <img src={s3_img_url + 'product_list/apnt.svg'} alt="" />
                        SEE IT IN PERSON
                      </Link>
                    </div>
                    <ul className="single_pro_features list_style_none">
                      <li>
                        {shippingBus}
                        <br /> FREE Fast Shipping
                      </li>
                      <li>
                        <svg
                          width="40"
                          height="40"
                          viewBox="0 0 12 12"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g clip-path="url(#clip0_12_110)">
                            <path
                              d="M1.26497 2.72797C1.28877 2.73274 1.31257 2.73274 1.33875 2.72678L2.96073 2.37636C3.06188 2.35371 3.12495 2.25479 3.10353 2.15467C3.08211 2.05574 2.98453 1.99138 2.88219 2.01283L1.54105 2.30365L1.81832 0.962772C1.83974 0.862653 1.77548 0.763726 1.67552 0.742272C1.57318 0.719626 1.4756 0.78518 1.45656 0.886491L1.1186 2.50747C1.1067 2.56826 1.12336 2.63262 1.16858 2.67672C1.19595 2.70413 1.22927 2.72082 1.26497 2.72797Z"
                              fill="#3A5755"
                            />
                            <path
                              d="M5.62873 3.71388C5.5728 3.7103 5.50378 3.71388 5.42524 3.72699C5.00159 3.79731 4.77668 4.1084 4.73027 4.43855H4.73979C4.83499 4.31221 5.00159 4.20732 5.22175 4.20732C5.57637 4.20732 5.82508 4.46358 5.82508 4.85452C5.82508 5.22163 5.57637 5.56013 5.16106 5.56013C4.73384 5.56013 4.453 5.22759 4.453 4.70673C4.453 4.31221 4.59342 4.00113 4.79096 3.80446C4.95756 3.63998 5.17772 3.53867 5.43119 3.50887C5.51211 3.49576 5.57875 3.49219 5.62873 3.49219V3.71388ZM5.55257 4.86883C5.55257 4.58277 5.38954 4.40995 5.13963 4.40995C4.9766 4.40995 4.82547 4.51126 4.75169 4.65667C4.73384 4.68647 4.72194 4.72818 4.72194 4.77705C4.72908 5.10601 4.87902 5.34916 5.16224 5.34916C5.39549 5.34916 5.55257 5.15488 5.55257 4.86883Z"
                              fill="#3A5755"
                            />
                            <path
                              d="M7.54464 4.50167C7.54464 5.18224 7.29236 5.55888 6.84968 5.55888C6.45817 5.55888 6.19517 5.19177 6.18803 4.53027C6.18803 3.85923 6.47721 3.48975 6.883 3.48975C7.30545 3.48975 7.54464 3.86519 7.54464 4.50167ZM6.45817 4.53385C6.45817 5.0547 6.61882 5.35029 6.86515 5.35029C7.14123 5.35029 7.27451 5.02729 7.27451 4.51597C7.27451 4.02372 7.14956 3.69952 6.86872 3.69952C6.63072 3.69952 6.45817 3.98796 6.45817 4.53385Z"
                              fill="#3A5755"
                            />
                            <path
                              d="M3.17136 6.55023C3.33439 6.5252 3.52836 6.50732 3.74137 6.50732C4.12455 6.50732 4.39944 6.59552 4.58032 6.76597C4.76477 6.93641 4.87187 7.17598 4.87187 7.51209C4.87187 7.85059 4.76834 8.1283 4.57437 8.319C4.3804 8.51328 4.06029 8.61698 3.65688 8.61698C3.46767 8.61698 3.30702 8.60744 3.17136 8.59195V6.55023ZM3.4403 8.38575C3.50813 8.39886 3.60571 8.40125 3.71043 8.40125C4.28163 8.40125 4.59341 8.08063 4.59341 7.52043C4.59579 7.03176 4.31971 6.72067 3.75446 6.72067C3.61523 6.72067 3.51051 6.73259 3.4403 6.74689V8.38575Z"
                              fill="#3A5755"
                            />
                            <path
                              d="M5.70488 7.94607L5.48949 8.59923H5.21222L5.91789 6.52295H6.23919L6.94724 8.59923H6.66164L6.43792 7.94607H5.70488ZM6.38318 7.7363L6.18088 7.13797C6.13447 7.00328 6.10353 6.87933 6.07378 6.76014H6.06783C6.03689 6.8829 6.00357 7.00924 5.96311 7.13558L5.75962 7.7363H6.38318Z"
                              fill="#3A5755"
                            />
                            <path
                              d="M7.85998 8.59923V7.71842L7.20547 6.52295H7.51131L7.80286 7.09506C7.88259 7.25239 7.94566 7.37873 8.00873 7.52414H8.01468C8.07418 7.38946 8.14439 7.25239 8.22412 7.09625L8.52162 6.52414H8.82745L8.13249 7.71604V8.60042L7.85998 8.59923Z"
                              fill="#3A5755"
                            />
                            <path
                              d="M5.98096 11.9474C2.9524 11.9474 0.416504 9.6768 0.0785425 6.66607C0.0678325 6.55165 0.148753 6.45153 0.259423 6.43842C0.380804 6.43604 0.473624 6.50874 0.487904 6.62078C0.800875 9.42531 3.16184 11.5385 5.98096 11.5385C9.02975 11.5385 11.5097 9.05344 11.5097 5.9998C11.5097 2.94617 9.02856 0.462258 5.98096 0.462258C4.26022 0.462258 2.67037 1.24295 1.61246 2.60648C1.54106 2.69587 1.41492 2.71136 1.32567 2.64223C1.23523 2.57191 1.22095 2.44438 1.28997 2.35499C2.42404 0.89134 4.13527 0.0522461 5.98096 0.0522461C9.25585 0.0522461 11.9203 2.71971 11.9203 5.99861C11.9215 9.2799 9.25585 11.9474 5.98096 11.9474Z"
                              fill="#3A5755"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_12_110">
                              <rect width="12" height="12" fill="white" />
                            </clipPath>
                          </defs>
                        </svg>
                        <br /> FREE 60 Day Returns
                      </li>
                      <li>
                        <svg
                          width="53"
                          height="50"
                          viewBox="0 0 13 12"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g clip-path="url(#clip0_12_121)">
                            <path
                              d="M6.54727 4.42732C6.5063 4.42732 6.46612 4.41066 6.43539 4.37818L3.58564 1.36776C3.55491 1.33528 3.53915 1.2903 3.54073 1.24365C3.5423 1.19783 3.56121 1.15535 3.59351 1.12536C3.60297 1.1162 4.53818 0.242399 4.72727 0.0474802C4.75642 0.0174927 4.79661 0 4.83757 0H8.38618C8.42794 0 8.46812 0.0174927 8.49806 0.0491462L9.51442 1.12453C9.57588 1.1895 9.57588 1.29529 9.51442 1.36027L6.65836 4.37901C6.62764 4.4115 6.58667 4.42732 6.54727 4.42732ZM3.92758 1.25698L6.54727 4.02499L9.17958 1.24198L8.32079 0.334027H4.89982C4.69654 0.53561 4.17182 1.02874 3.92758 1.25698Z"
                              fill="#3A5755"
                            />
                            <path
                              d="M6.70407 0.200684H6.38971V4.26066H6.70407V0.200684Z"
                              fill="#3A5755"
                            />
                            <path
                              d="M9.40176 1.08301H3.6983V1.4162H9.40176V1.08301Z"
                              fill="#3A5755"
                            />
                            <path
                              d="M6.69697 4.31547L6.41806 4.16053L7.90636 1.15845L7.48721 0.238L7.77006 0.0947266L8.25855 1.16428L6.69697 4.31547Z"
                              fill="#3A5755"
                            />
                            <path
                              d="M6.42122 4.36395L4.85965 1.2136L5.34892 0.144043L5.63098 0.287317L5.21183 1.20693L6.70013 4.20985L6.42122 4.36395Z"
                              fill="#3A5755"
                            />
                            <path
                              d="M6.6694 11.9868C4.40661 11.9868 2.56534 10.0393 2.56534 7.64782C2.56534 5.25465 4.40661 3.30713 6.6694 3.30713C8.93297 3.30713 10.7742 5.25465 10.7742 7.64782C10.7742 10.0393 8.93297 11.9868 6.6694 11.9868ZM6.6694 3.64032C4.58152 3.64032 2.88049 5.43707 2.88049 7.64782C2.88049 9.85523 4.58073 11.6528 6.6694 11.6528C8.75885 11.6528 10.4599 9.85607 10.4599 7.64782C10.4591 5.43707 8.75885 3.64032 6.6694 3.64032Z"
                              fill="#3A5755"
                            />
                            <path
                              d="M12.0672 9.07287H0.931283C0.737465 9.07287 0.579102 8.90711 0.579102 8.70053V6.65471C0.579102 6.4498 0.737465 6.2832 0.931283 6.2832H12.068C12.2633 6.2832 12.4201 6.4498 12.4201 6.65471V8.6997C12.4201 8.90628 12.2626 9.07287 12.0672 9.07287Z"
                              fill="white"
                            />
                            <path
                              d="M12.0687 9.2404H0.931272C0.651575 9.2404 0.422302 8.998 0.422302 8.70146V6.65564C0.422302 6.3591 0.651575 6.1167 0.931272 6.1167H12.0695C12.3492 6.1167 12.5785 6.3591 12.5785 6.65564V8.70062C12.5777 8.998 12.3492 9.2404 12.0687 9.2404ZM0.931272 6.44989C0.82412 6.44989 0.737454 6.54069 0.737454 6.65564V8.70062C0.737454 8.81391 0.82412 8.90554 0.931272 8.90554H12.0695C12.1759 8.90554 12.2625 8.81391 12.2625 8.70062V6.65564C12.2625 6.54069 12.1759 6.44989 12.0695 6.44989H0.931272Z"
                              fill="#3A5755"
                            />
                            <path
                              d="M2.79068 8.13107L2.5748 7.23145H2.6914L2.79225 7.68709C2.81747 7.79954 2.84031 7.912 2.85528 7.99779H2.85765C2.87183 7.90866 2.89783 7.80287 2.92698 7.68542L3.04122 7.23145H3.15625L3.25947 7.68875C3.2831 7.79538 3.30595 7.902 3.31856 7.99696H3.32092C3.33825 7.89783 3.36268 7.79704 3.38947 7.68542L3.50213 7.23145H3.6148L3.37371 8.13107H3.25789L3.14995 7.6621C3.12395 7.54798 3.10662 7.46052 3.0948 7.36889H3.09322C3.07747 7.45885 3.05856 7.54715 3.02704 7.6621L2.90571 8.13107H2.79068Z"
                              fill="#3A5755"
                            />
                            <path
                              d="M4.1088 7.84785L4.01977 8.13107H3.90631L4.19467 7.23145H4.32783L4.61777 8.13107H4.50116L4.41055 7.84785H4.1088ZM4.38692 7.75789L4.30419 7.49883C4.28528 7.43969 4.27267 7.38638 4.25928 7.33474H4.25692C4.24431 7.38721 4.23013 7.44302 4.21516 7.49717L4.13086 7.75789H4.38692Z"
                              fill="#3A5755"
                            />
                            <path
                              d="M4.99359 7.24377C5.04953 7.23127 5.12911 7.22461 5.20396 7.22461C5.32135 7.22461 5.39777 7.2471 5.45056 7.29874C5.49389 7.33873 5.51832 7.40037 5.51832 7.46951C5.51832 7.58862 5.44741 7.66692 5.35759 7.69858V7.70274C5.42299 7.7269 5.46317 7.79021 5.48286 7.88433C5.51044 8.00928 5.53092 8.09675 5.54826 8.1309H5.4348C5.42062 8.10591 5.40092 8.02844 5.37808 7.91599C5.35208 7.79271 5.30717 7.74523 5.20711 7.74189H5.10468V8.1309H4.99359V7.24377ZM5.10468 7.6536H5.21735C5.33396 7.6536 5.4088 7.58612 5.4088 7.48283C5.4088 7.36622 5.32923 7.31624 5.21262 7.31457C5.16062 7.31457 5.12202 7.3204 5.10468 7.32623V7.6536Z"
                              fill="#3A5755"
                            />
                            <path
                              d="M5.92487 7.24377C5.98002 7.23044 6.06038 7.22461 6.13602 7.22461C6.25341 7.22461 6.32905 7.2471 6.38262 7.29874C6.42438 7.33873 6.44881 7.40037 6.44881 7.46951C6.44881 7.58862 6.3779 7.66692 6.28808 7.69858V7.70274C6.35347 7.7269 6.39287 7.79104 6.41335 7.88433C6.44093 8.00928 6.4622 8.09675 6.47874 8.1309H6.36529C6.35111 8.10591 6.3322 8.02844 6.30856 7.91599C6.28335 7.79271 6.23765 7.74523 6.13838 7.74189H6.03438V8.1309H5.92487V7.24377ZM6.03438 7.6536H6.14705C6.26444 7.6536 6.3385 7.58612 6.3385 7.48283C6.3385 7.36622 6.25893 7.31624 6.14311 7.31457C6.09032 7.31457 6.0525 7.3204 6.03438 7.32623V7.6536Z"
                              fill="#3A5755"
                            />
                            <path
                              d="M6.99244 7.84785L6.90419 8.13107H6.79074L7.0791 7.23145H7.21226L7.5022 8.13107H7.3848L7.2942 7.84785H6.99244ZM7.27135 7.75789L7.18783 7.49883C7.16971 7.43969 7.1571 7.38638 7.14371 7.33474H7.14135C7.12874 7.38721 7.11456 7.44302 7.0988 7.49717L7.01529 7.75789H7.27135Z"
                              fill="#3A5755"
                            />
                            <path
                              d="M7.87878 8.13107V7.23145H7.99854L8.27115 7.68709C8.33418 7.79288 8.38381 7.88701 8.42321 7.9803L8.42636 7.97863C8.41533 7.85785 8.41375 7.74956 8.41375 7.60962V7.23145H8.51697V8.13107H8.40666L8.13563 7.67543C8.07733 7.57464 8.0206 7.47218 7.97727 7.37472L7.97254 7.37638C7.97963 7.4905 7.982 7.59796 7.982 7.74706V8.13107H7.87878Z"
                              fill="#3A5755"
                            />
                            <path
                              d="M9.12128 7.33057H8.86285V7.23145H9.49316V7.33057H9.23316V8.13107H9.12128V7.33057Z"
                              fill="#3A5755"
                            />
                            <path
                              d="M10.0289 8.13107V7.7504L9.75946 7.23145H9.88395L10.0037 7.48051C10.0368 7.54881 10.062 7.60296 10.088 7.66626H10.0912C10.114 7.60796 10.1432 7.54881 10.1762 7.48051L10.2984 7.23145H10.4229L10.1384 7.74873V8.13107H10.0289Z"
                              fill="#3A5755"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_12_121">
                              <rect width="13" height="12" fill="white" />
                            </clipPath>
                          </defs>
                        </svg>
                        <br /> FREE Lifetime Warranty
                      </li>
                      {
                        productdetail?.category_id == "1" && <li>
                          <svg
                            width="50"
                            height="50"
                            viewBox="0 0 136 173"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M60.9748 64.1323C60.3668 64.1323 59.7528 63.8923 59.2858 63.4243L16.0038 20.1472C15.5358 19.6852 15.2958 19.0362 15.3078 18.3762C15.3308 17.7222 15.6168 17.0972 16.1088 16.6642C16.2658 16.5362 30.4638 3.97426 33.3458 1.17426C33.7898 0.748255 34.4038 0.490234 35.0118 0.490234H88.9158C89.5528 0.490234 90.1598 0.760242 90.6168 1.19824L106.072 16.6403C106.516 17.0963 106.768 17.7092 106.768 18.3292C106.768 18.9612 106.516 19.5743 106.072 20.0303L62.6778 63.4243C62.2078 63.8923 61.5878 64.1323 60.9748 64.1323ZM21.1988 18.5573L60.9748 58.3333L100.985 18.3292L87.9218 5.29425H35.9708C32.8768 8.18725 24.8938 15.2893 21.1988 18.5573Z"
                              fill="#3F5654"
                            />
                            <path
                              d="M63.3839 3.3833H58.5959V61.7293H63.3839V3.3833Z"
                              fill="#3F5654"
                            />
                            <path
                              d="M104.369 16.0625H17.7039V20.8555H104.369V16.0625Z"
                              fill="#3F5654"
                            />
                            <path
                              d="M63.2599 62.5125L59.0229 60.2844L81.632 17.1425L75.267 3.92743L79.562 1.85742L86.986 17.2354L63.2599 62.5125Z"
                              fill="#3F5654"
                            />
                            <path
                              d="M59.0867 63.2024L35.3438 17.9254L42.7787 2.54736L47.0748 4.61639L40.6987 17.8314L63.3187 60.9753L59.0867 63.2024Z"
                              fill="#3F5654"
                            />
                            <path
                              d="M62.8509 172.733C28.4589 172.733 0.483887 144.759 0.483887 110.378C0.483887 75.9965 28.4589 48.0215 62.8509 48.0215C97.2319 48.0215 125.207 75.9965 125.207 110.378C125.207 144.759 97.2319 172.733 62.8509 172.733ZM62.8509 52.8095C31.1009 52.8095 5.27087 78.6285 5.27087 110.378C5.27087 142.111 31.0999 167.928 62.8509 167.928C94.5839 167.928 120.414 142.111 120.414 110.378C120.414 78.6275 94.5839 52.8095 62.8509 52.8095Z"
                              fill="#3F5654"
                            />
                            <path
                              d="M63.0259 141.141C62.2309 141.141 61.4769 140.744 61.0389 140.07C49.6059 122.944 34.4029 107.864 28.4059 102.176C27.4469 101.265 27.4129 99.7442 28.3179 98.7862C29.2419 97.8282 30.7379 97.7922 31.7079 98.6932C37.4659 104.159 51.5468 118.128 62.9378 134.39C71.0208 121.641 102.744 73.0511 130.899 48.7011C131.892 47.8521 133.722 47.6482 134.593 48.6422C135.469 49.6232 135.71 50.8451 134.739 51.7171C134.728 51.7171 134.044 52.3182 134.032 52.3302C102.182 79.8612 65.4279 139.393 65.0599 139.99C64.6389 140.697 63.8849 141.118 63.0719 141.141H63.0259Z"
                              fill="#3F5654"
                            />
                          </svg>
                          <br /> 365 Day Exchange
                        </li>
                      }
                    </ul>
                    <div className="single_pro_description">
                      <Accordion>
                        <Accordion.Item eventKey="0">
                          <Accordion.Header>PRODUCT DETAILS</Accordion.Header>
                          <Accordion.Body>
                            <p className="overview">
                              {productdetail?.description}
                            </p>
                            <Row>
                              {productdetail?.attribute?.general?.length ? (
                                <Col md={12}>
                                  <h6>GENERAL</h6>
                                  <p>
                                    {productdetail?.attribute?.general?.map(
                                      (val) => (
                                        <>
                                          <span className="text-uppercase">
                                            {val?.title}
                                          </span>{" "}
                                          : {val?.value}
                                          <br />
                                        </>
                                      )
                                    )}
                                  </p>
                                </Col>
                              ) : (
                                ""
                              )}
                              {productdetail?.attribute?.center_stone
                                ?.length ? (
                                <Col md={12}>
                                  <h6>CENTER STONE</h6>
                                  <p className="">
                                    {productdetail?.attribute?.center_stone?.map(
                                      (val) =>
                                        val?.title != "Ring Setting Options" ? (
                                          <>
                                            <span className="text-uppercase">
                                              {val?.title}
                                            </span>
                                            : {val?.value}
                                            <br />
                                          </>
                                        ) : (
                                          <>
                                            <span className="text-uppercase">
                                              {val?.title}
                                            </span>
                                            :<br />
                                            {val?.value?.map((val1) => (
                                              <img
                                                className="mt-2"
                                                height={30}
                                                src={val1?.image}
                                                alt={val1?.name}
                                              />
                                            ))}
                                          </>
                                        )
                                    )}
                                  </p>
                                </Col>
                              ) : (
                                ""
                              )}
                            </Row>
                          </Accordion.Body>
                        </Accordion.Item>
                      </Accordion>
                    </div>
                  </div>
                  {/* single product filter form end */}
                </Form>
              </Col>
            </Row>
          )}
          {loader && !loader2 ? <div id="preloader"></div> : ""}
        </Container>
      </section>
      <Order_include />
      {suggesteddata?.suggested?.data?.length > 0 && (
        <section className="rings_you_may_love mt-3">
          <Container fluid className="p-0">
            <h2>{suggesteddata?.suggested?.title}</h2>
            {suggesteddata?.suggested?.data?.length ? (
              <Rings
                type="Rings"
                add_to_wishlist={add_to_wishlist}
                klaviyo_Wishlist={klaviyo_Wishlist}
                kleviyoRemoveWishlist={kleviyoRemoveWishlist}
                data={suggesteddata?.suggested?.data}
                productdetailapi={(val1, val2) => productdetailapi(val1, val2)}
              />
            ) : (
              <Single_product_ring_skeleton />
            )}
          </Container>
        </section>
      )}

      <section className="rings_you_may_love pb-5 mt-3">
        <Container fluid className="p-0">
          {suggesteddata?.pairing?.data?.length ? (
            <>
              <h2 className="text-uppercase">
                {suggesteddata?.pairing?.title}
              </h2>

              <Rings
                type="Bands"
                add_to_wishlist={add_to_wishlist}
                klaviyo_Wishlist={klaviyo_Wishlist}
                kleviyoRemoveWishlist={kleviyoRemoveWishlist}
                data={suggesteddata?.pairing?.data}
                productdetailapi={(val1, val2) => productdetailapi(val1, val2)}
              />
            </>
          ) : (
            <Single_product_ring_skeleton />
          )}
        </Container>
      </section>

      <Modal
        show={modalshow}
        onHide={handleClose}
        className="send_hint"
        size="lg"
        centered
        backdropClassName="green-backdrop"
      >
        <span onClick={handleClose} className="sent-hint-close">
          x
        </span>
        <Modal.Body>
          <div className="send_hint_head text-center">
            <h3>SEND A HINT!</h3>
            <p>Let someone know exactly what you want.</p>
          </div>
          <Form onSubmit={HintSubmit}>
            <Row>
              <Col lg={6} md={6}>
                <div className="hintBox">
                  <p className="txt">TO:</p>
                  <Form.Group className="persone-info">
                    <Form.Control
                      type="text"
                      placeholder="FIRST NAME"
                      onChange={(e) => inputHandler(e)}
                      value={hintData?.to_name}
                      onBlur={validateOne}
                      name="to_name"
                    />
                    {validations?.to_name && (
                      <div className="validation mt-0">
                        {validations?.to_name.replace("_", " ")}
                      </div>
                    )}
                  </Form.Group>
                  <Form.Group className="persone-info">
                    <Form.Control
                      type="email"
                      placeholder="EMAIL"
                      onChange={(e) => inputHandler(e)}
                      value={hintData?.to_email}
                      onBlur={validateOne}
                      name="to_email"
                    />
                    {validations?.to_email && (
                      <div className="validation mt-0">
                        {validations?.to_email.replace("_", " ")}
                      </div>
                    )}
                  </Form.Group>
                  <p className="txt mt-4">FROM:</p>
                  <Form.Group className="persone-info">
                    <Form.Control
                      type="text"
                      placeholder="FIRST NAME"
                      onChange={(e) => inputHandler(e)}
                      value={hintData?.from_name}
                      onBlur={validateOne}
                      name="from_name"
                    />
                    {validations?.from_name && (
                      <div className="validation mt-0">
                        {validations?.from_name.replace("_", " ")}
                      </div>
                    )}
                  </Form.Group>
                  <Form.Group className="persone-info">
                    <Form.Control
                      type="email"
                      placeholder="EMAIL"
                      onChange={(e) => inputHandler(e)}
                      value={hintData?.from_email}
                      onBlur={validateOne}
                      name="from_email"
                    />
                    {validations?.from_email && (
                      <div className="validation mt-0">
                        {validations?.from_email.replace("_", " ")}
                      </div>
                    )}
                  </Form.Group>
                  <Form.Group className="persone-info messagebox">
                    <Form.Control
                      as="textarea"
                      placeholder="MESSAGE (OPTIONAL)"
                      onChange={(e) => inputHandler(e)}
                      value={hintData?.message}
                      name="message"
                    />
                  </Form.Group>
                </div>
              </Col>
              <Col lg={6} md={6}>
                <div className="productBox text-center d-flex align-items-center">
                  <div>
                    <img src={drophintimg} alt={productdetail?.name} />
                    <p>{productdetail?.name}</p>
                  </div>
                </div>
              </Col>
            </Row>
            <Form.Group className="persone-info-btn text-center mt-4">
              <Button type="submit" className="theme_btn">
                {loaderApi ? "Sending..." : "SEND HINT"}
              </Button>
            </Form.Group>
          </Form>
        </Modal.Body>
      </Modal>

      {/* Book Appointment Modal */}

      <Modal
        show={bookAppointmentShow}
        onHide={bookAppointment_handleClose}
        className="send_hint BookAppointment_modal"
        size="lg"
        centered
        backdropClassName="green-backdrop"
      >
        <span onClick={bookAppointment_handleClose} className="sent-hint-close">
          x
        </span>
        <Modal.Body>
          <div className="send_hint_head text-center">
            <h3>BOOK AN APPOINTMENT!</h3>
            <p>Let us know exactly what you want.</p>
          </div>
          <InPersonConsultation
            bookAppointment_handleClose={bookAppointment_handleClose}
            type="product"
            product_id={productdetail?.product_id}
          />
        </Modal.Body>
      </Modal>

      {/* Free Gift modal */}
      <Modal
        show={freeGiftShow}
        onHide={freeGift_handleClose}
        className="send_hint freeGift_modal"
        size="lg"
        centered
        backdropClassName="green-backdrop"
      >
        <span
          onClick={() => {
            freeGift_handleClose();
            setShowMore(false);
          }}
          className="sent-hint-close"
        >
          x
        </span>
        <Modal.Body>
          {/* {productdetail?.offer_product?.length ? ( */}
          <div className="send_hint_head">
            <Row className={freeGiftDec == true ? "d-none" : ""}>
              <Col md={3} xs={4}>
                <img
                  src={offerProductValue?.img}
                  alt="Free Gift"
                  className="img-fluid"
                />
              </Col>
              <Col md={9} xs={8}>
                <h3>{offerProductValue?.name}</h3>
                <p>
                  {showMore ? offerProductValue?.description : initialText}
                  {/* {offerProductValue ?.description?.substring(
                      0,
                      260,
                    )}{' '} */}
                  {!showMore && (
                    <span onClick={() => setShowMore(true)}>Learn More</span>
                  )}
                </p>
              </Col>
            </Row>

            {/* <div className={freeGiftDec == true ? 'detail_desc' : 'd-none'}>
                <IoIosArrowRoundBack onClick={() => setfreeGiftDec(false)} />
                <Row>
                  <Col md={3}>
                    <img
                      src={productdetail?.offer_product[0]?.img}
                      alt="Free Gift"
                      className="img-fluid"
                    />
                  </Col>
                  <Col md={9}>
                    <h3>{productdetail?.offer_product[0]?.name}</h3>
                    <p>{productdetail?.offer_product[0]?.description}</p>
                  </Col>
                </Row>
              </div> */}
          </div>
          {/* ) : (
            ' ' */}
          {/* )} */}
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Single_product;
